import React, { useEffect, useState } from 'react';
import { clarityEvent, gaEvent } from '../analytics';
import WaitlistSignup from './WaitlistSignup';
import styles from './InceptumLandingControls.module.css';

export default function InceptumLandingControls({
  experiment,
  exploreTarget,
  storyWaitlistVisible = false,
}) {
  const [showExplore, setShowExplore] = useState(true);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [inlineWaitlistVisible, setInlineWaitlistVisible] = useState(false);
  const isLazyTreatment = experiment.treatment?.startsWith('e');

  useEffect(() => {
    const handleScroll = () => setShowExplore(window.scrollY < 100);
    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    const input = document.getElementById('hero-waitlist-email');
    if (!input) {
      setInlineWaitlistVisible(false);
      return undefined;
    }
    const observer = new IntersectionObserver(
      ([entry]) => setInlineWaitlistVisible(entry.isIntersecting),
      { threshold: 0.5 }
    );
    observer.observe(input);
    return () => observer.disconnect();
  }, [experiment.treatment]);

  useEffect(() => {
    if (!drawerOpen) return undefined;
    const handleKeyDown = (event) => {
      if (event.key === 'Escape') setDrawerOpen(false);
    };
    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [drawerOpen]);

  useEffect(() => {
    const handleOpenWaitlist = () => setDrawerOpen(true);
    window.addEventListener('open-inceptum-waitlist', handleOpenWaitlist);
    return () => window.removeEventListener('open-inceptum-waitlist', handleOpenWaitlist);
  }, []);

  const handleExplore = () => {
    const destination = document.getElementById(exploreTarget);
    if (!destination) return;
    gaEvent('landing_explore_click', {
      treatment: experiment.treatment || 'organic',
      destination: exploreTarget,
    });
    clarityEvent('landing_explore_click');
    destination.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };

  const openWaitlist = () => {
    gaEvent('ig_floating_waitlist_click', { treatment: experiment.treatment });
    clarityEvent('ig_floating_waitlist_click');
    setDrawerOpen(true);
  };

  return (
    <>
      {showExplore && !drawerOpen && !isLazyTreatment && (
        <button type="button" className={styles.exploreCue} onClick={handleExplore}>
          <span>Explore</span>
          <span className={styles.chevron} aria-hidden="true" />
        </button>
      )}

      {experiment.isExperiment && !drawerOpen && !inlineWaitlistVisible && !storyWaitlistVisible && (
        <button type="button" className={styles.floatingWaitlist} onClick={openWaitlist}>
          Join waitlist
        </button>
      )}

      {experiment.isQa && (
        <span className={styles.qaBadge}>QA · {experiment.treatment.toUpperCase()}</span>
      )}

      {drawerOpen && (
        <div
          className={styles.drawerBackdrop}
          role="presentation"
          onClick={() => setDrawerOpen(false)}
        >
          <div
            className={styles.drawer}
            role="dialog"
            aria-modal="true"
            aria-label="Join the waitlist"
            onClick={(event) => event.stopPropagation()}
          >
            <button
              type="button"
              className={styles.closeButton}
              onClick={() => setDrawerOpen(false)}
              aria-label="Close waitlist form"
            >
              ×
            </button>
            <WaitlistSignup
              id="ig_floating"
              formName="ig_floating_waitlist"
              inputId="ig-floating-waitlist-email"
              heading="Get preorder access"
              blurb="Leave your email and we’ll let you know when preorders open."
              buttonLabel="Join waitlist"
              variant="drawer"
            />
          </div>
        </div>
      )}
    </>
  );
}